// src/components/CreateEventModal.js
import axios from "axios";

function CreateEventModal({
  isOpen,
  onClose,
  newEvent,
  setNewEvent,
  currentUser,
  auth,
  API_BASE_URL,
  employees,
  fetchAllEvents,
  setToast,
}) {
  if (!isOpen) return null;

  const handleCreateEvent = async () => {
    if (!currentUser) return;

    const missingFields = [];
    if (!newEvent.event_type) missingFields.push("Event Type");
    if (!newEvent.title?.trim()) missingFields.push("Event Title");
    if (!newEvent.date_and_time) missingFields.push("Date & Time");
    if (!newEvent.primary_technician) missingFields.push("Primary Technician");

    if (missingFields.length > 0) {
      setToast({
        message: `⚠️ Please fill out the following required field(s): ${missingFields.join(", ")}`,
        type: "error",
      });
      return;
    }

    try {
      const token = await auth.currentUser.getIdToken(true);

      const res = await axios.post(
        `${API_BASE_URL}/api/event/create/`,
        {
          event_type: newEvent.event_type,
          title: newEvent.title,
          description: newEvent.description,
          date_and_time: newEvent.date_and_time,
          primary_technician: newEvent.primary_technician,
        },
        {
          headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      console.log("Create Response:", res.data);
      setToast({ message: "✅ Event created", type: "success" });
      onClose();
      setNewEvent({
        event_type: "",
        title: "",
        date_and_time: "",
        primary_technician: "",
        description: "",
      });
      fetchAllEvents();
    } catch (err) {
      console.error("Create failed:", err);
      setToast({
        message: `⚠️ Create failed: ${err.response?.data?.error || err.message || "Unknown error"}`,
        type: "error",
      });
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-xl shadow-xl max-w-md w-full font-sans">
        <h3 className="text-xl font-bold mb-4 text-purple-700">Create Event</h3>
        <div className="space-y-3">
          <select
            className="w-full border px-3 py-2 rounded bg-white"
            value={newEvent.event_type}
            onChange={(e) => setNewEvent({ ...newEvent, event_type: e.target.value })}
          >
            <option value="" disabled>Event Type</option>
            <option value="travel">Travel / Driving / Van</option>
            <option value="office">Office / Corporate</option>
            <option value="rest">Rest / PTO / Personal Leave</option>
            <option value="training">Training / Orientation / Fusionsplice / (High/Low) Top Van</option>
            <option value="no_job">No Job</option>
          </select>

          <input
            type="text"
            placeholder="Event Title"
            value={newEvent.title}
            onChange={(e) => setNewEvent({ ...newEvent, title: e.target.value })}
            className="w-full border px-3 py-2 rounded"
          />

          <input
            type="datetime-local"
            value={newEvent.date_and_time}
            onChange={(e) => setNewEvent({ ...newEvent, date_and_time: e.target.value })}
            className="w-full border px-3 py-2 rounded"
          />

          <select
            className="w-full border px-3 py-2 rounded bg-white"
            value={newEvent.primary_technician || ""}
            onChange={(e) => setNewEvent({ ...newEvent, primary_technician: e.target.value })}
          >
            <option value="" disabled>Primary Technician</option>
            {employees.slice().sort((a, b) => a.name.localeCompare(b.name)).map(emp => (
              <option key={emp.id} value={emp.name}>{emp.name}</option>
            ))}
          </select>

          <input
            placeholder="Description (optional)"
            value={newEvent.description}
            onChange={(e) => setNewEvent({ ...newEvent, description: e.target.value })}
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div className="mt-6 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
          >Cancel</button>

          <button
            onClick={handleCreateEvent}
            className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700"
          >Create</button>
        </div>
      </div>
    </div>
  );
}

export default CreateEventModal;
